import { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

export function SubscribeIconInfo({
  size = 16,
  color = 'white',
  ...props
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8.00004C14.6663 4.31814 11.6816 1.33337 7.99967 1.33337C4.31778 1.33337 1.33301 4.31814 1.33301 8.00004C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g>
          <path
            d="M8.00684 10.6666V7.99996"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.00684 5.33337H8.00017"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  )
}
